export default __webpack_public_path__ + "static/media/user.0153113d.svg";